import client from './client';

/** Fetches the customer's claims — the same data as fetchData()'s bundle, on its own. */
export async function fetchClaims() {
  const response = await client.get('/api/care-portal/data/claims');
  return response.data.claims;
}

/** Fetches the additional questions for a given claim loss type. */
export async function fetchAdditionalQuestions(claimLossTypeId) {
  const response = await client.get('/api/care-portal/claim-questions', {
    params: { claimLossTypeId },
  });
  return response.data.questions;
}

/** Submits a new claim against one of the customer's policies, returning the new claim's id. */
export async function submitClaim({
  policyId,
  dateOfLoss,
  claimLossTypeId,
  claimCauseTypeId,
  claimCausalPartId,
  claimantEmail,
  mileageOnDol,
  causeNotes,
  questionsAnswers,
}) {
  const response = await client.post('/api/care-portal/claims', {
    policyId,
    dateOfLoss,
    claimLossTypeId,
    claimCauseTypeId,
    claimCausalPartId,
    claimantEmail,
    mileageOnDol,
    causeNotes,
    questionsAnswers,
  });

  return { claimId: response.data.claimId };
}
